/**
 * Helper functions for managing tour events across the application
 */

/**
 * Dispatches an event to mark a tour step as completed
 * @param {string} stepId - The ID of the tour step to mark as completed
 */
export const completeTourStep = (stepId) => {
  try {
    console.log(`Dispatching tour completion event for step: ${stepId}`);
    // Create and dispatch a custom event that ProductTour component will listen for
    const event = new CustomEvent("tourStepComplete", {
      detail: { stepId },
      bubbles: true,
    });
    window.dispatchEvent(event);
  } catch (error) {
    console.warn("Error triggering tour step completion:", error);
  }
};

/**
 * Helper to mark the widget_controls step as completed when a user interacts with a widget's styling
 */
export const completeWidgetControlsStep = () => {
  completeTourStep("widget_controls");
};

/**
 * Helper to mark the drag_and_drop step as completed when a user drags a widget
 */
export const completeDragAndDropStep = () => {
  completeTourStep("drag_and_drop");
};

/**
 * Tour step IDs for reference
 */
export const TOUR_STEP_IDS = {
  DRAG_AND_DROP: "drag_and_drop",
  WIDGET_CONTROLS: "widget_controls",
  THEME_SELECTOR: "theme_selector",
  WIDGET_SELECTOR: "widget_selector",
  PREVIEW_OPTIONS: "preview_options",
  SPACE_SETTINGS: "space_settings",
  PUBLISH_BUTTON: "publish_button",
};
